import React, { useEffect, useState } from 'react'
import UserLayout from '../util/UserLayout'

const UserDetails = () => {

  const [user, setUser] = useState({name:"", email:""})

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user"))
    if (userDetails) { 
      setUser(userDetails)
    }
  }, [])
  

  return (
    <UserLayout>
         <form>
        <div className="row">
          <div className="col-12">
            {/* Email */}
            <div className="form-group">
              <label htmlFor="accountFirstName">
                Name
              </label>
              <input className="form-control form-control-sm" id="accountFirstName" type="text" placeholder="First Name *" value={user.name} required disabled />
            </div>
          </div>
          <div className="col-12">
            {/* Email */}
            <div className="form-group">
              <label htmlFor="accountEmail">
                Email Address
              </label>
              <input className="form-control form-control-sm" id="accountEmail" type="email" placeholder="Email Address *" value={user.email} required disabled />
            </div>
          </div>
          <div className="col-12 col-md-6">
            {/* Password */}
            <div className="form-group">
              <label htmlFor="accountPassword">
                Current Password *
              </label>
              <input className="form-control form-control-sm" id="accountPassword" type="password" placeholder="Current Password *" required />
            </div>
          </div>
          <div className="col-12 col-md-6">
            {/* Password */}
            <div className="form-group">
              <label htmlFor="AccountNewPassword">
                New Password *
              </label>
              <input className="form-control form-control-sm" id="AccountNewPassword" type="password" placeholder="New Password *" required />
            </div>
          </div>
          <div className="col-12">
            {/* Button */}
            <button className="btn btn-dark" type="submit">Save Changes</button>
          </div>
        </div>
      </form>
    </UserLayout>
  )
}

export default UserDetails